import { render, staticRenderFns } from "./list-return-reject-form.vue?vue&type=template&id=5165c700&"
import script from "./list-return-reject-form.vue?vue&type=script&lang=js&"
export * from "./list-return-reject-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports